import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { IComponentIdsRegistry } from './types'

export const name = 'domSelectors' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

// Re-export from thunderbolt-symbols to avoid circular dependencies
export { DomSelectorsSymbol } from '@wix/thunderbolt-symbols'

// Symbol for component IDs registry (shared between site/page/editor)
export const ComponentIdsRegistrySymbol = createIdentifier<IComponentIdsRegistry>(Symbol('ComponentIdsRegistry'))
